interface IntroPanelProps {
  className: string;
}

const STEPS = [
  {
    lead: "We Handle the Handoff:",
    body: "Your transaction data automatically goes to Connect Services 21 days before closing with no extra work for you.",
  },
  {
    lead: "More Value for Your Clients:",
    body: "Clients get helpful information about move-in services, plus access to exclusive discounts that can help them save along the way.",
  },
  {
    lead: "White Glove Care:",
    body: "A dedicated rep helps your clients understand their options, answer questions, and navigate utilities, internet, security, and other move-in services.",
  },
];

const IntroPanel = ({ className }: IntroPanelProps) => (
  <div data-cy="connect-services-step-1" className={className}>
    {/*
      The design's own spacing (16px between sections, 24px between steps) makes
      this content 348px tall, but the stage is a fixed 328px shared by all four
      steps. Rather than grow the modal, both gaps are scaled down by the same
      factor — 16 -> 12 and 24 -> 18 — which preserves the design's 1.5 ratio and
      lands the content at exactly 328px. This wrapper owns the section gap so
      PANEL_BASE's 16px (shared with the other three panels) collapses to a
      single child and never applies here.
    */}
    <div className="tw-flex tw-flex-col tw-gap-[12px]">
      <h1 className="tw-m-0 tw-text-center tw-text-28d tw-font-normal tw-text-gray-75">
        {"Your Customer's Move Simplified"}
      </h1>

      <ol className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-[18px] tw-pl-[16px]">
        {STEPS.map(({ lead, body }, index) => (
          <li key={lead} className="tw-flex tw-items-start tw-gap-[8px]">
            <span className="tw-flex tw-h-[32px] tw-w-[32px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[var(--brand-lightest)] tw-text-14d tw-font-semibold tw-text-[var(--brand-dark)]">
              {index + 1}
            </span>
            <p className="tw-m-0 tw-flex-1 tw-text-14d tw-font-normal tw-text-gray-75">
              <span className="tw-font-semibold">{lead} </span>
              {body}
            </p>
          </li>
        ))}
      </ol>

      <div className="tw-flex tw-items-center tw-gap-[10px] tw-rounded-[4px] tw-bg-tinted-gray-50 tw-px-[24px] tw-py-[16px]">
        <p className="tw-m-0 tw-flex-1 tw-text-14d tw-font-normal tw-text-gray-75">
          And the best part?
          <br />
          This service is{" "}
          <span className="tw-font-semibold tw-text-[var(--brand-dark)]">
            completely free for you and your clients.
          </span>
        </p>
        <span className="tw-shrink-0 tw-text-28d tw-font-normal tw-text-gray-75">$0</span>
      </div>
    </div>
  </div>
);

export default IntroPanel;
